import React, { SyntheticEvent, useState, useEffect } from 'react'
import styles from './UploadImg.module.scss'
import {
  useDeleteDeviceImageMutation,
  useUploadDeviceImageMutation,
} from './service'
import { LoadingButton } from '@mui/lab'
import { useParams } from 'react-router-dom'
import { Dialog } from '@/components'
import DialogQuestion from '@/components/Dialog/Dialog'
import { useGetUserProfileQuery } from '@/modules/user/services/userService'
import { UserTypes } from '@/types/typeUser'

interface Props {
  url?: string
}

const UploadFeaturesImg = ({ url = '' }: Props) => {
  const { id } = useParams()
  const { data: currentUserData } = useGetUserProfileQuery('0')
  const canUploadImage = currentUserData?.data.typeId === UserTypes.superAdmin

  const [imgUrl, setImgUrl] = useState(url)
  const [openDialogSave, setOpenDialogSave] = useState(false)
  const [showImagePreview, setShowImagePreview] = useState(false)
  const [loading, setLoading] = useState(false)
  const [addImage] = useUploadDeviceImageMutation()
  const [deleteImage] = useDeleteDeviceImageMutation()

  useEffect(() => {
    setImgUrl(url)
  }, [url])

  useEffect(() => {
    if (!imgUrl) setShowImagePreview(false)
  }, [imgUrl])

  const handleRemovePhoto = async () => {
    setLoading(true)
    try {
      await deleteImage({ deviceId: Number(id) })
      setImgUrl('')
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
      setOpenDialogSave(false)
    }
  }
  const handleAddPhoto = async (e: SyntheticEvent) => {
    const { files } = e.target as HTMLInputElement
    if (e.target && files?.length && id) {
      setLoading(true)
      try {
        const formData = new FormData()
        formData.append('deviceId', id)
        formData.append('image', files[0])
        const result = await addImage(formData).unwrap()
        setImgUrl(result.imageUrl ?? '')
      } catch (e) {
        console.error(e)
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <>
      <Dialog
        message='Изображение будет удалено. Вы уверены?'
        open={openDialogSave}
        handleClose={() => setOpenDialogSave(false)}
        handleAgree={() => {
          handleRemovePhoto()
        }}
      />
      <DialogQuestion
        open={showImagePreview}
        handleClose={() => setShowImagePreview(false)}
        handleAgree={() => setShowImagePreview(false)}
        disableGutters={true}
        message={
          <div>
            <img
              style={{
                width: '100%',
                maxHeight: '85vh',
                objectFit: 'contain',
              }}
              src={imgUrl}
              alt=''
            />
          </div>
        }
        agreeText='Закрыть'
        showClose={false}
        fullWidth={true}
        maxWidth={false}
      />
      <div className={styles.Wrapper}>
        {imgUrl && (
          <div>
            <img
              className={styles.UploadedImage}
              src={imgUrl}
              alt=''
              onClick={() => setShowImagePreview(true)}
            />
          </div>
        )}
        <div>
          {canUploadImage && (
            <>
              <LoadingButton
                variant={'text'}
                component='label'
                loading={loading}
              >
                Загрузить {!imgUrl && ' изображение'}
                <form>
                  <input
                    id='photosInput'
                    type='file'
                    hidden
                    accept='.jpg, .jpeg, .png, .gif'
                    onChange={handleAddPhoto}
                  />
                </form>
              </LoadingButton>
              <br />
              {imgUrl && (
                <LoadingButton
                  variant={'text'}
                  component='label'
                  loading={loading}
                  color='error'
                  onClick={() => setOpenDialogSave(true)}
                >
                  Удалить
                </LoadingButton>
              )}
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default UploadFeaturesImg
